import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './app/apiServices/allApi';
import App from './app/App';
import 'atropos/css'

ReactDOM.render(

  <BrowserRouter>

     <App />

  </BrowserRouter >
  , document.getElementById('root'));

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(`${process.env.PUBLIC_URL}/service-worker.js`)
    .catch((error) => console.error("PWA service worker registration failed:", error));
}






